export const USE_PERF = false

export const TASK_DEADLINE = 10
